export const STORAGE_KEY = 'helpful';

export const MAX_CONTENT_WIDTH = 744;

export const DEFAULT_TEXT_ZOOM = 1;

export const TOAST_DURATION = 7000;
